import "./SwipeableModals.scss";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import { useState, useEffect } from "react";
import api from "../../../utils/api";
import { toast } from "react-toastify";
import Chat from "../../../components/Chat/Chat";

const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  initialData = null,
  refreshData,
  selectedRow = null,
  selectedId = null,
  onDescriptionSubmit,
  loading = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [question, setQuestion] = useState({
    question_ar: "",
    question_en: "",
  });
  const [description, setDescription] = useState("");

  console.log(selectedRow);
  console.log(selectedId);
  useEffect(() => {
    if (initialData && currentView === "editQuestion") {
      setQuestion({
        question_ar: initialData.question_ar || "",
        question_en: initialData.question_en || "",
      });
    } else {
      setQuestion({
        question_ar: "",
        question_en: "",
      });
    }

    // Set description from selectedRow if available
    if (currentView === "addDescription" && selectedRow) {
      setDescription(selectedRow.description || "");
    } else if (currentView !== "addDescription") {
      setDescription("");
    }
  }, [initialData, currentView, selectedRow]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Create URLSearchParams object instead of FormData
      const params = new URLSearchParams();
      // Append multilingual question fields
      params.append("question[ar]", question.question_ar);
      params.append("question[en]", question.question_en);

      // Create custom config for Axios to use x-www-form-urlencoded
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          // Authorization header will be added by the interceptor
        },
      };

      if (currentView === "createQuestion") {
        await api.post("/support_questions", params, config);
        toast.success("تم إضافة السؤال بنجاح");
      } else if (currentView === "editQuestion") {
        await api.put(`/support_questions/${initialData.id}`, params, config);
        toast.success("تم تحديث السؤال بنجاح");
      }

      // Call refreshData to trigger data refresh in parent component
      if (refreshData) {
        refreshData();
      }
      onClose();
    } catch (error) {
      toast.error(error.message || "حدث خطأ ما");
    } finally {
      setIsLoading(false);
      setQuestion({
        question_ar: "",
        question_en: "",
      });
    }
  };

  const handleDescriptionSubmit = async (e) => {
    e.preventDefault();
    if (onDescriptionSubmit) {
      await onDescriptionSubmit(description);
      setDescription("");
    }
  };

  const renderQuestionForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "createQuestion" ? "اضافة سؤال جديد" : "تعديل السؤال"}
      </p>
      <form onSubmit={handleSubmit}>
        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel
            htmlFor="question-title-ar"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            عنوان السؤال (عربي)
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="question-title-ar"
            type="text"
            value={question.question_ar}
            onChange={(e) =>
              setQuestion({ ...question, question_ar: e.target.value })
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <InputLabel
            htmlFor="question-title-en"
            shrink
            sx={{
              background: "white",
              transformOrigin: "left top",
              transform: "translate(-14px, -9px) scale(0.75)",
              left: 24,
              right: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            عنوان السؤال (بالانجليزية)
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="question-title-en"
            type="text"
            value={question.question_en}
            onChange={(e) =>
              setQuestion({ ...question, question_en: e.target.value })
            }
          />
        </FormControl>

        <BlueButton
          text={currentView === "createQuestion" ? "اضافة" : "تحديث"}
          size="medium"
          variant="fill"
          loading={isLoading}
          type="submit"
        />
      </form>
    </div>
  );

  const renderDescriptionForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">ملاحظات</p>
      <form onSubmit={handleDescriptionSubmit}>
        <FormControl sx={{ width: "100%", mb: 2 }} variant="outlined">
          <OutlinedInput
            sx={{
              borderRadius: "8px",
              minHeight: "120px",
              alignItems: "flex-start",
              padding: "12px",
            }}
            multiline
            rows={5}
            placeholder="اكتب ملاحظاتك هنا..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormControl>

        <BlueButton
          text="حفظ"
          size="medium"
          variant="fill"
          loading={loading}
          type="submit"
          sx={{
            backgroundColor: "#00BCD4",
            borderRadius: "8px",
            padding: "12px 24px",
            width: "100%",
          }}
        />
      </form>
    </div>
  );

  const renderViewChat = () => (
    <Chat selectedRow={selectedRow} selectedId={selectedId} />
  );

  const renderDefaultView = () => <div></div>;

  const views = {
    createQuestion: renderQuestionForm,
    editQuestion: renderQuestionForm,
    addDescription: renderDescriptionForm,
    viewChat: renderViewChat,
  };

  // Get drawer width based on current view
  const getDrawerWidth = () => {
    switch (currentView) {
      case "viewChat":
        return "500px";
      default:
        return "400px";
    }
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{
        zIndex: "1202",
        "& .MuiDrawer-paper": {
          width: getDrawerWidth(),
          maxWidth: "90vw",
        },
      }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
